import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [user, setUser] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (token) {
      const fetchUserData = async () => {
        try {
          const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/auth/user`, {
            headers: { Authorization: `Bearer ${token}` },
          });

          if (!response.ok) {
            throw new Error("Failed to fetch user data");
          }

          const data = await response.json();
          setUser(data.user);
          setIsAuthenticated(true);
        } catch (error) {
          console.error(error);
          setIsAuthenticated(false);
        }
      };

      fetchUserData();
    } else {
      setIsAuthenticated(false);
    }
  }, []);

  if (isAuthenticated === null) {
    return <div className="loading-spinner">Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} />;
  }

  // Special check for service routes
  const serviceRoutes = {
    '/service1': 'isUSAEnabled',
    '/tax-filing': 'isTaxFilingEnabled',
    '/bookkeeping': 'isBookkeepingEnabled',
    '/cfo': 'isCFOEnabled',
    '/registered-agent': 'isRegisteredAgentEnabled',
    '/annual-report': 'isAnnualReportServiceEnabled',
  };

  const currentPath = location.pathname;
  if (serviceRoutes[currentPath] && !user[serviceRoutes[currentPath]]) {
    return <Navigate to="/pricing" state={{ from: location }} />;
  }

  return children;
};
export default PrivateRoute;
